import t from 'tcomb'

export default t.interface({
	getId: t.Function,
}, 'Model')
